import cardApi from '../api/cardApi'
import  {Auth, Storage} from 'aws-amplify';
import _ from 'lodash'
import moment from 'moment'


export const CardDetailActions = {
    getCardDetails,
    fetchPriceHistory,
    getPlayerName,
    getDetailsFromImage,
    getNeedList,
    checklistInit
}

function getCardDetails(cardObj) {
    return async (dispatch) => {
        let userLoggedIn = true
        try {
             await Auth.currentAuthenticatedUser()
        }
        catch (e) {
            userLoggedIn = false
        }
        if (userLoggedIn) {
            Auth.currentSession().then( async res=>{
                let authTok = res.getIdToken().jwtToken
                let params =  {card_id: cardObj.label}
                console.log('raw cxheck ' + cardObj.graded)
                if (cardObj.graded !== 'RAW') {
                    console.log('not raw')
                    //add in grade selector
                    params.grade = cardObj.graded + ' ' + cardObj.condition
                }
                const options = {
                    headers: {
                        Authorization: authTok    
                    },
                    params
                }
                console.log(params)
                try {
                    const response = await cardApi.get('/card/details', options)
                    dispatch({
                        type: 'GET_CARD_DETAILS_RESPONSE',
                        payload: response.data.stats
                    }) 
                }
                catch (e) {
                    dispatch({
                        type: 'GET_CARD_DETAILS_RESPONSE',
                        payload: {}
                    }) 

                }
                //console.log(JSON.stringify(response.data.stats))
                
            })
        }
        else {
            console.log('user not logged in - skipping')
        }
            
    }
}

function getPlayerName(cardData) {
    return async (dispatch) => {
        Auth.currentSession().then( async res=>{
            try {
                let authTok = res.getIdToken().jwtToken
                const label = 'CARD_' + cardData.setName.replace(/ /g, '_').toUpperCase() + '_' + cardData.cardNum
                console.log('GPN ' + label)
                let params =  {card_id: label}
                const options = {
                    headers: {
                        Authorization: authTok    
                    },
                    params
                }
                const response = await cardApi.get('/card/catalog', options)
                console.log('ACTION GOT ' + JSON.stringify(response.data))
                dispatch({
                    type: 'GET_PLAYER_RESPONSE',
                    payload: response.data[0].player.trim()
                }) 
            }
            catch (e){}
        })
            
    }
}

function fetchPriceHistory(cardLabel, cardGrade) {
    return async (dispatch) => {
        Auth.currentSession().then( async res=>{
            let authTok = res.getIdToken().jwtToken
            let params =  {
                card_id: cardLabel,
                grade: cardGrade.trim(),
                fullDetails: true
            }
            const options = {
                headers: {
                    Authorization: authTok    
                },
                params
            }

            let formattedResult = {}

            const response = await cardApi.get('/card/details', options)
            let groupedResults = _.groupBy(response.data.queryData, (result) => moment(result['endDate'], 'YYYY-MM-DD').startOf('isoWeek').format('YYYY-MM-DD'));
            //Group data by week to smooth the responses out
            //console.log('GR ' + JSON.stringify(groupedResults))
            let average = (arr) => arr.reduce((a, b) => a + b) / arr.length // Get Avg price of all items in that week
            for (var week in groupedResults) {
                let prices = []
                console.log('OK '  + week)
                console.log(groupedResults[week])
                for (var auc of groupedResults[week]) {
                    //console.log(auc.price)
                    prices.push(auc.price)
                }

                //console.log('AVG ' + average)
                formattedResult[week] = average(prices)
            }
            console.log(formattedResult)
            
            // for (const dataPoint of response.data.queryData) {
            //     formattedResult[dataPoint.endDate] =  dataPoint.price
            // }
            
             dispatch({
                 type: 'GET_PRICE_DETAILS_RESPONSE',
                 payload: formattedResult
             }) 
        })
            
    }
}

function getDetailsFromImage(imgObj) {
    return async (dispatch) => {
        Auth.currentSession().then( async res=>{
            let authTok = res.getIdToken().jwtToken
            //FIXME - need to get the image in there = probably from the react page AddCardModal
            //const tempImg = await Storage.put(imgName)
            const fileRes = await Storage.put(imgObj.name, imgObj, {contentType: "image/png"})
            const imgPsURL = await Storage.get(imgObj.name)
            console.log('AAA ' + JSON.stringify(fileRes))
            console.log('BBB' + JSON.stringify(imgPsURL))
           let imgParts = JSON.stringify(imgPsURL).split('//')[1].split('/')  //remove the htttps://
            let bucketName = imgParts[0].split('.')[0] 
            let path = unescape(imgParts[1]+'/'+ imgParts[2] + '/' + imgParts[3].split('?')[0])
            console.log('bucket ' + bucketName)
            console.log('path ' + path)
            let params =  {
                srcBucket: bucketName,
                srcKey: path
            }
            const options = {
                headers: {
                    Authorization: authTok    
                },
                params
            }
            try {   
                const response = await cardApi.get('/card/readImg', options)
                console.log('CCC ' + JSON.stringify(response.data))
                dispatch({
                    type: 'GET_IMG_RESPONSE',
                    payload: response.data
                }) 
            }
            catch (e) {
                console.log('ERROR WITH IMAGE ' + e)
                dispatch({
                    type: 'GET_IMG_RESPONSE',
                    payload: {}
                }) 
            }
        })
            
    }
}

function checklistInit() {
    return async (dispatch) => {
        dispatch({
            type: 'CHECKLIST_INIT'
        })    
    }
}
function getNeedList(setId) {
    return async (dispatch) => {
        Auth.currentSession().then( async res=>{
            try {
                let authTok = res.getIdToken().jwtToken
                let userName = res.getAccessToken().payload.username
                //console.log('uname ' + userName)
                let params =  {
                    set_id: setId,
                    owner_id: userName,
                    fullChecklist: true
                }
                const options = {
                    headers: {
                        Authorization: authTok    
                    },
                    params
                }
                const response = await cardApi.get('/manage/collection', options)
                const  sortedChecklist = _.sortBy(response.data, [function(o) { return parseInt(o.cardNum) }])
                //console.log('NeedList GOT ' + JSON.stringify(response.data))
                 dispatch({
                     type: 'CHECKLIST_RESPONSE',
                     payload: sortedChecklist
                 }) 
            }
            catch (e){}
        })
            
    }
}